import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * One Supabase client per build target — `persistSession` differs
 * deliberately (plan L317-322). The business client persists its auth
 * session in localStorage so a receptionist's login survives a page reload
 * at the desk; the admin client persists nothing, not even the auth
 * session, so an admin tab always starts from a real sign-in, matching
 * spec §3's "admin sessions are shorter, bound to hardware-key/TOTP"
 * posture. Neither build wires a TanStack Query persister (plan.md
 * "Offline" section: "The admin build persists nothing" — the business
 * entry doesn't add one either, so that stays true for both without extra
 * code here).
 */
export function createPortalSupabaseClient(persistSession: boolean): SupabaseClient {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (!url || !anonKey) {
    throw new Error(
      'VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing — copy portal/.env.example to .env.local and fill it in',
    );
  }
  return createClient(url, anonKey, {
    auth: {
      persistSession,
      autoRefreshToken: persistSession,
      detectSessionInUrl: true,
    },
  });
}
